






















import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as service from '@/services/crm-dashboard';
import { PaginationSyncDTO, ResultPagDTO } from '@/interfaces/base-dto';
import { DashboardFiltrosDTO } from '@/interfaces/crm-dashboard';
import { BehaviorSubject } from 'rxjs';

@Component({
  components: {
    ListMessages
  }
})
export default class VisitsDataTableCharts extends BaseComponent {
  @Prop()
  filters: any;

  items = [];
  pagination: PaginationSyncDTO = new PaginationSyncDTO();
  pagina: ResultPagDTO<any> = new ResultPagDTO();
  loading = false;
  error = false;

  public headers: any = [
    { text: 'Data', value: 'data', sortable: true },
    { text: 'Cliente', value: 'cliente', sortable: true },
    { text: 'Consultores', value: 'consultores', sortable: true },
    { text: 'Modalidade', value: 'modalidade', sortable: true },
    { text: 'Planejamento', value: 'planejamento', sortable: true },
    { text: 'Duração (min)', value: 'duracaoMinutos', sortable: true },
    { text: 'Contatos', value: 'qtdeContatos', sortable: true },
  ];

  beforeMount() {
    this.buildBs();
  }

  @Watch('filters', { immediate: true })
  filtersWatch(v) {
    this.pagination.page = 1;
    this.load();
  }

  bs$: BehaviorSubject<any> = new BehaviorSubject(null);

  buildBs() {
    this.bs$ = this.buildBehaviorSubject((f) => {
      return service.listCrmDashboardAnalyticData(f);
    }, () => this.loading = true, 300, (res) => {
      this.items = res.content;
      this.loading = false;
      this.pagina = res;
      PaginationSyncDTO.update(this.pagination, res);
    }, (error) => {
      this.loading = false;
      this.error = true;
      this.showToastApiError(error);
      this.buildBs();
    });
  }

  load() {
    let filters = Object.assign(new DashboardFiltrosDTO(), this.filters);
    filters.update(this.pagination);
    this.loading = true;
    this.items = [];
    this.bs$.next(filters);
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  onChangePagination() {
    this.load();
  }
}
